import { TextField } from "@material-ui/core";
import { FC, useEffect, useState } from "react";

import Spacing from "../../../components/Spacing";
import { GenericObject } from "../../../types/generic.types";

const INTIAL_VALUE = {
  instagram: "",
  twitter: "",
  facebook: "",
  tiktok: "",
  youtube: "",
  website: "",
  snapchat: "",
};

const SocialMediaLinks: FC<any> = ({ handleSocialLinks, defaultValue = INTIAL_VALUE, handleSocialLinksError }) => {
  const [socialLinks, setSocialLinks] = useState(defaultValue);

  const validateSocialMediaLinks = (links: GenericObject) => {
    const checkIsvalidLink = (link: any) => {
      const linkRegex = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/gm;
      return link[1] ? (linkRegex.test(link[1]) ? false : true) : false;
    };
    const isValidLink = Object.entries(links).some(checkIsvalidLink);
    handleSocialLinksError(isValidLink);
  };

  useEffect(() => {
    handleSocialLinks(socialLinks);
    validateSocialMediaLinks(socialLinks);
  }, [socialLinks]);

  return (
    <>
      <Spacing containerStyle={{ marginBottom: 24 }}>
        <TextField
          label="Instagram"
          name={socialLinks.instagram}
          value={socialLinks.instagram}
          onChange={(e) => setSocialLinks({ ...socialLinks, instagram: e.target.value })}
          variant="outlined"
          fullWidth
          size="small"
        />
        <TextField
          label="Twitter"
          name={socialLinks.twitter}
          value={socialLinks.twitter}
          onChange={(e) => setSocialLinks({ ...socialLinks, twitter: e.target.value })}
          variant="outlined"
          fullWidth
          size="small"
        />
      </Spacing>
      <Spacing containerStyle={{ marginBottom: 24 }}>
        <TextField
          label="Tiktok"
          name={socialLinks.tiktok}
          value={socialLinks.tiktok}
          onChange={(e) => setSocialLinks({ ...socialLinks, tiktok: e.target.value })}
          variant="outlined"
          fullWidth
          size="small"
        />
        <TextField
          label="Youtube"
          name={socialLinks.youtube}
          value={socialLinks.youtube}
          onChange={(e) => setSocialLinks({ ...socialLinks, youtube: e.target.value })}
          variant="outlined"
          fullWidth
          size="small"
        />
      </Spacing>
      <Spacing containerStyle={{ marginBottom: 24 }}>
        <TextField
          label="Facebook"
          name={socialLinks.facebook}
          value={socialLinks.facebook}
          onChange={(e) => setSocialLinks({ ...socialLinks, facebook: e.target.value })}
          variant="outlined"
          fullWidth
          size="small"
        />
        <TextField
          label="Website"
          name={socialLinks.website}
          value={socialLinks.website}
          onChange={(e) => setSocialLinks({ ...socialLinks, website: e.target.value })}
          variant="outlined"
          fullWidth
          size="small"
        />
      </Spacing>
      <TextField
        label="Snapchat"
        name={socialLinks.snapchat}
        value={socialLinks.snapchat}
        onChange={(e) => setSocialLinks({ ...socialLinks, snapchat: e.target.value })}
        variant="outlined"
        fullWidth
        size="small"
      />
    </>
  );
};

export default SocialMediaLinks;
